/**

 * Application: MR PSK Enterprises Platform

 * Owner: MR PSK Enterprises Inc.

 * CEO: Paramveer Singh Kahlon

 *

 * Description:

 * This application is a proprietary software platform developed,

 * owned, and operated by MR PSK Enterprises Inc. as part of its

 * active commercial operations in the United States.

 *

 * Purpose:

 * The platform supports business operations including customer

 * engagement, booking, payment processing, and service management.

 *

 * Investment Context (E-2 Visa):

 * This software constitutes an integral part of the investor’s

 * committed capital and demonstrates active enterprise development

 * under MR PSK Enterprises Inc.

 *

 * All intellectual property, infrastructure, and associated assets

 * are fully owned and funded by MR PSK Enterprises Inc.

 *

 * © MR PSK Enterprises Inc. All rights reserved.

 */

import { ThemeProviderWrapper } from './Theme';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from '@/firebaseApp';
import { APIProvider } from "@vis.gl/react-google-maps"
import MainPage from '@/Pages/MainPage';
import SignInPage from './Pages/SignIn';
import RoutePreviewPage from './Pages/RoutePreview';
import { ROUTES } from './Routes';
import { Box, useTheme } from '@mui/material';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer';
import EmailConfirmDialog from '@/components/EmailConfirmDialogBox';

const key = process.env.REACT_APP_GOOGLE_MAPS_KEY as string;

function App() {

  const theme = useTheme()

  return (
    <BrowserRouter>
      <ThemeProviderWrapper>
        <AuthProvider>
          <APIProvider
            apiKey={key}
            libraries={["places", "geometry", "marker"]}
          >
            <Box sx={{
              display: "flex",
              flexDirection: "column",
              background: theme.palette.customBackground
            }}>
              <Header />

              <Box sx={{ flex: 1, minWidth: '80vw' }}>

                <EmailConfirmDialog />

                <Routes>
                  <Route path={ROUTES.HOME} element={<MainPage />} />
                  <Route path={ROUTES.SIGN_IN} element={<SignInPage />} />
                  <Route path={ROUTES.ROUTES_PREVIEW} element={<RoutePreviewPage />} />

                </Routes>
              </Box>
              <Footer />
            </Box>
          </APIProvider>
        </AuthProvider>
      </ThemeProviderWrapper>

    </BrowserRouter>

  );
}

export default App;
